// extracted by mini-css-extract-plugin
export default {"heading":"percentGoal_heading__Q-zfm","gaugeBackground":"percentGoal_gaugeBackground__Hlsmf"};